import React, { FC } from 'react'

type ListSectionHeaderProps = {
  label: string
}

const ListSectionHeader: FC<ListSectionHeaderProps> = ({ label }) => (
  <h2 className="sticky top-0 z-10 bg-page px-4 py-2 text-base font-heading font-bold leading-snug text-foreground break-words">
    {label}
  </h2>
)

export default ListSectionHeader
